var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tray',{attrs:{"top":68,"right":12,"open-percentage":_vm.subNavigationTrayOpenPercentage},on:{"openPercentageChangeRequest":_vm.setSubNavigationTrayOpenPercentage}},[_c('div',{staticClass:"container"},[_c('DashboardsList')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }